import * as expression from "../../data/base/expressions"
import { API, message } from '../../api'
import { FAMOUS_PEDIA_DATA_MANAGER } from '../../data';
import { CONFIG } from "../../config";

export default {
    namespaced: true,
    state: {
        showPediaCommentAllList: false,
        showPediaCommentReplyTo: false,
        commentTextAreaToName: '',
        commentAllKey: '',
        commentAllYear: '',
        commentAllTitle: '',
        commentAllContent: '',
        commentAllSort: 1,
        commentAllSelectedList: [],
        commentAllMainList: [],
        showPediaCommentMore: false,
        curCommentMoreData: {},
        curCommentMoreFromMe: false,
        showPediaCommentReport: false,
        showPediaCommentReportSuc: false,
        commentTotalReplyData: {},
        commentTotalReplySecondData: {},
        commentTotalUserInfo: {},
        commentFormDataChanged: false,
        commentFormData: {},
        expressionList: [],
        showPediaCommentEvent: true,
        showPediaCommentFateFortune: true
    },
    mutations: {},
    actions: {
        initCommentList({ dispatch, state }, baikeId) {
            console.log('initCommentList------', baikeId)
            API.getBaiKeReplyList({
                bid: baikeId
            }, function(data) {
                console.log('获取评论列表信息成功:::::::', data)
                state.commentTotalUserInfo = data.userinfo;
                var resultData = FAMOUS_PEDIA_DATA_MANAGER.getCommentTotalDataByData(data);
                state.commentTotalReplyData = Object.assign(resultData.first, state.commentTotalReplyData);
                state.commentTotalReplySecondData = Object.assign(resultData.second, state.commentTotalReplySecondData);
                // 更新大运流年的评论数据
                var curPediaDayunLiunianList = AppFate.$store.state.famouspedia.curPediaDayunLiunianList;
                dispatch('minifatefortune/updateFamousMiniFortuneListCommentStatus', {
                    pediaList: curPediaDayunLiunianList,
                    commentData: state.commentTotalReplyData
                }, {root: true});
            });
            // 表情部分
            state.expressionList = expression.CONST_EXPRESSION;
        },
        initCommentAllListData({ state }, params) {
            var curCommentList = [], resultData = {},
                curPediaPipanInfo = AppFate.$store.state.famouspedia.curPediaPipanInfo,
                curPediaDayunLiunianList = AppFate.$store.state.famouspedia.curPediaDayunLiunianList;
            // 这里和全部数据有联系了
            curCommentList = state.commentTotalReplyData[params.key];
            curCommentList = curCommentList ? curCommentList : [];
            if(curCommentList.length > 0) {
                resultData = FAMOUS_PEDIA_DATA_MANAGER.getCommentAllListDataByList(curCommentList);
                state.commentAllSelectedList = resultData.good;
                state.commentAllMainList = resultData.main;
            }else {
                state.commentAllSelectedList = [];
                state.commentAllMainList = [];
            }
            state.commentAllKey = params.key;
            if(params.key == 'all') {
                // 评论:all
                state.commentAllYear = '';
                state.commentAllTitle = '命盘整体';
                state.commentTextAreaToName = '命盘整体分析';
                state.commentAllContent = curPediaPipanInfo ? curPediaPipanInfo.base : '';
            }else {
                // 评论:流年
                var resultData = FAMOUS_PEDIA_DATA_MANAGER.getCommentAllDataInfoByKey(params.key, curPediaDayunLiunianList);
                if(resultData) {
                    state.commentAllYear = 'liunian' + resultData.year;
                    state.commentAllTitle = resultData.year + resultData.ganzhi + '流年';
                    state.commentTextAreaToName = resultData.year + resultData.ganzhi + '流年';
                    state.commentAllContent = resultData.content;
                }
            }
            console.log('initCommentAllListData------', params.key, state.commentAllYear, curPediaPipanInfo, curCommentList, state.commentTextAreaToName)
            setTimeout(() => {
                state.showPediaCommentAllList = true;
            }, 10);
        // 执行回调函数
            if(params.cb && typeof(params.cb) == 'function') {
                params.cb();
            }
        },
        initCommentAllListMore({ state }, params) {
            if(CONFIG.platform != 'web') {
                state.showPediaCommentMore = true;
            }
            state.curCommentMoreData = params.data;
            state.curCommentMoreFromMe = params.userData && parseInt(params.data.uid) == parseInt(params.userData.uid) ? true : false;
            // state.curCommentMoreFromMe = true;    // for test
            console.log('initCommentAllListMore-----', params.userData, params.data.uid, state.curCommentMoreFromMe)
        },
        setCommentFormData({ state }, params) {
            state.commentFormDataChanged = true;
            state.commentFormData = Object.assign({}, params.formData);
            console.log('setCommentFormData----', state.commentFormData)

            if(params.cb && typeof(params.cb) == 'function') {
                params.cb();
            }
        },
        addComment({ dispatch, state }, params) {
            console.log('addComment-------', state.commentFormData);
            if(!state.commentFormData.bid){
                return;
            }
            state.commentFormData.msg = params.msg;
            // return;

            API.addBaiKeReply(state.commentFormData, function(data) {
                console.log('评论成功:::::::', data.ret);
                // 更新本地评论列表二级评论数据
                if(state.commentFormData.parentsid != 0) {
                    // 更新本地评论列二级评论数据
                    dispatch('updateTotalCommentSecondList', data.ret);
                }else {
                    // 更新本地评论列表一级评论数据
                    dispatch('updateTotalComment', data.ret);
                }
                // 评论成功后，重置评论表单数据
                if(state.showPediaCommentAllList) {
                    dispatch('resetCommentAllFormData', {
                        bid: state.commentFormData.bid
                    });
                // }else {
                    // dispatch('resetCommentFormData');
                }
                // 更新热门名人记录列表数据的评论人数
                dispatch('famouspedia/updateHotListCommentNum', null, {root: true});

                // 执行回调函数
                if(params.sucCb && typeof(params.sucCb) == 'function') {
                    params.sucCb();
                }
            }, function() {
                // 执行回调函数
                if(params.failCb && typeof(params.failCb) == 'function') {
                    params.failCb();
                }
            })
        },
        updateTotalComment({ state }, id) {
            var userData = AppFate.$store.state.userData, userInfo = {},
                curPediaBaziId = AppFate.$store.state.famouspedia.curPediaBaziId,
                newData = FAMOUS_PEDIA_DATA_MANAGER.supplyCommentDataByFormData(state.commentFormData, {
                    id: id,
                    bid: curPediaBaziId,
                    uid: userData.info && userData.info.uid ? userData.info.uid : 0,
                    reply: []
                }),
                addedData = {}, addedObj = {};
            if(userData && userData.info) {
                userInfo[userData.info.uid] = userData.info;
            }
            userInfo = Object.assign(userInfo, state.commentTotalUserInfo);
            addedData = FAMOUS_PEDIA_DATA_MANAGER.getCommentData(newData, userInfo)
            var curObj = state.commentTotalReplyData[addedData['key']];
            console.log('updateTotalComment:::::::', userData, newData, addedData, curObj);
            if(!curObj) {
                addedObj[addedData['key']] = [];
            }else {
                addedObj[addedData['key']] = [].concat(curObj);
            }
            addedObj[addedData['key']].push(addedData);
            state.commentTotalReplyData = Object.assign(state.commentTotalReplyData, addedObj);

            // 在查看全部评论的列表下增加全部评论列表的数据
            if(state.showPediaCommentAllList) {
                state.commentAllMainList.push(addedData);
            }
        },
        updateTotalCommentSecondList({ state }, id) {
            var userData = AppFate.$store.state.userData, userInfo = {},
                curPediaBaziId = AppFate.$store.state.famouspedia.curPediaBaziId,
                newData = FAMOUS_PEDIA_DATA_MANAGER.supplyCommentDataByFormData(state.commentFormData, {
                    id: id,
                    bid: curPediaBaziId,
                    uid: userData.info && userData.info.uid ? userData.info.uid : 0,
                }),
                addedData = {}, addedObj = {};;
            if(userData && userData.info) {
                userInfo[userData.info.uid] = userData.info;
            }
            userInfo = Object.assign(userInfo, state.commentTotalUserInfo);
            addedData = FAMOUS_PEDIA_DATA_MANAGER.getCommentData(newData, userInfo)
            console.log('updateTotalCommentSecondList---------', addedData, userInfo)
            var curObj = state.commentTotalReplySecondData[addedData['parentsid']];
            if(!curObj) {
                addedObj[addedData['parentsid']] = [];
            }else {
                addedObj[addedData['parentsid']] = [].concat(curObj);
            }
            addedObj[addedData['parentsid']].push(addedData);
            state.commentTotalReplySecondData = Object.assign(state.commentTotalReplySecondData, addedObj);
            // 更新数据:待优化
            AppFate.$bus.emit('updateSecondList');
        },
        toggleLikeComment({ dispatch }, params) {
            console.log('toggleLikeComment-------', params)
            var baikeId = params.baikeId,
                commentId = params.data.id,
                isLike = params.data.isLike;
            // 点赞
            if(isLike == 0) {
                API.addBaiKeReplyLike({
                    bid: baikeId,
                    rid: commentId
                }, function(data) {
                    if(data.ret) {
                        console.log('评论点赞成功:::::::', data)
                        dispatch('updateTotalCommentLikeStatus', params.data);
                    }
                })
            }else {
                API.deleteBaiKeReplyLike({
                    bid: baikeId,
                    rid: commentId
                }, function(data) {
                    if(data.ret) {
                        console.log('取消评论点赞成功:::::::', data)
                        dispatch('updateTotalCommentLikeStatus', params.data);
                    }
                })
            }
        },
        updateTotalCommentLikeStatus({ state }, data) {
            var curKey = data.key,
                curList = state.commentTotalReplyData[curKey];
            console.log('updateTotalCommentLikeStatus------', state.commentTotalReplyData, data)
            if(curList && curList.length > 0) {
                for(var i = 0; i < curList.length; i++) {
                    if(data.parentsid == 0 && curList[i].id == data.id) {
                        state.commentTotalReplyData[curKey][i].likeNum = curList[i].isLike == 0 ? curList[i].likeNum + 1 : curList[i].likeNum - 1;
                        state.commentTotalReplyData[curKey][i].isLike = curList[i].isLike == 0 ? 1 : 0;
                        return;
                    }
                    if(data.parentsid != 0) {            
                        var secondList = state.commentTotalReplySecondData[data.parentsid];
                        for(var j = 0; j < secondList.length; j++) {
                            if(secondList[j].id == data.id && secondList[j].parentsid == data.parentsid) {
                                state.commentTotalReplySecondData[data.parentsid][j].likeNum = secondList[j].isLike == 0 ? secondList[j].likeNum + 1 : secondList[j].likeNum - 1;
                                state.commentTotalReplySecondData[data.parentsid][j].isLike = secondList[j].isLike == 0 ? 1 : 0;
                                return;
                            }
                        }
                    }
                }
            }
        },
        deleteComment({ dispatch, state }, params) {
            var curId = state.curCommentMoreData ? state.curCommentMoreData.id : null;
            if(curId == null) {
                state.showPediaCommentMore = false;
                if(params.failCb && typeof(params.failCb) == 'function') {
                    params.failCb();
                }
                return;
            }
            console.log('deleteComment-------', state.curCommentMoreData, curId)
            API.deleteBaiKeReply({
                rid: curId
            }, function(data) {
                if(data.ret) {
                    console.log('删除评论成功:::::::')
                    dispatch('deleteTotalComment', state.curCommentMoreData);
                    state.showPediaCommentMore = false;
                    state.curCommentMoreData = {};
                    state.curCommentMoreFromMe = false;

                    if(params.cb && typeof(params.cb) == 'function') {
                        params.cb();
                    }
                }
            })
        },
        deleteTotalComment({ state }, data) {
            console.log('deleteTotalComment------', data)
            var firstList = state.commentTotalReplyData[data.key];
                for(var i = 0; i < firstList.length; i++) {
                    if(data.parentsid == 0) {
                        // 删除一级列表的数据
                        if(firstList[i].id == data.id) {
                            state.commentTotalReplyData[data.key][i].isDelete = true;
                            if(state.commentTotalReplySecondData[data.id]) {
                                state.commentTotalReplySecondData[data.id].splice(0);
                            }
                            return;
                        }
                    }else {
                        // 删除二级列表的数据
                        var secondList = state.commentTotalReplySecondData[data.parentsid];
                        for(var j = 0; j < secondList.length; j++) {
                            if(secondList[j].id == data.id) {
                                state.commentTotalReplySecondData[data.parentsid][j].isDelete = true;
                                return;
                            }
                        }
                    }
                }
        },
        reportComment({ state }, params) {
            console.log('reportComment-----', params, state.curCommentMoreData.id)
            API.reportBaiKeReply({
                bid: params.bid,
                rid: state.curCommentMoreData.id,
                type: params.type,
                msg: params.msg
            }, function(data) {
                if(data.ret) {
                    console.log('举报评论成功:::::::')
                    state.showPediaCommentReportSuc = true;
                }
            })
        },
        resetCommentFormData({ state }){
            state.commentFormDataChanged = false;
            state.commentFormData = {};
            state.commentTextAreaToName = '';
        },
        resetCommentAllFormData({ state }, params) {
            state.commentFormData = Object.assign({}, params);
            state.commentFormData = Object.assign({
                f_type: state.commentAllKey,
                parentsid: 0,
                touid: 0
            }, state.commentFormData)
            console.log('resetCommentAllFormData------', state.commentFormData)
            state.commentTextAreaToName = state.commentAllTitle;
        },
        resetAllData({ state }) {
            state.showPediaCommentMore = false;
            state.curCommentMoreData = {};
            state.curCommentMoreFromMe = false;
            state.showPediaCommentReport = false;
            state.showPediaCommentReportSuc = false;
            state.showPediaCommentAllList = false;
            state.showPediaCommentReplyTo = false;
            state.commentTextAreaToName = '';
            state.commentAllKey = '';
            state.commentAllYear = '';
            state.commentAllTitle = '';
            state.commentAllContent = '';
            state.commentAllSort = 1;
            state.commentAllSelectedList = [];
            state.commentAllMainList = [];
            state.showPediaCommentEvent = true;
            state.showPediaCommentFateFortune = true;
        },
        resetData({ state }) {
            state.commentTotalReplyData = {};
            state.commentTotalReplySecondData = {};
            state.commentTotalUserInfo = {};
            state.commentFormDataChanged = false;
            state.commentFormData = {};
            state.expressionList = [];

            state.showPediaCommentMore = false;
            state.curCommentMoreData = {};
            state.curCommentMoreFromMe = false;
            state.showPediaCommentReport = false;
            state.showPediaCommentReportSuc = false;
            state.showPediaCommentAllList = false;
            state.showPediaCommentReplyTo = false;
            state.commentTextAreaToName = '';
            state.commentAllKey = '';
            state.commentAllYear = '';
            state.commentAllTitle = '';
            state.commentAllContent = '';
            state.commentAllSort = 1;
            state.commentAllSelectedList = [];
            state.commentAllMainList = [];
            state.showPediaCommentEvent = true;
            state.showPediaCommentFateFortune = true;
        }
    }
}